<template>
    <div>
        <!-- Begin:PageContent:Main -->
        <section id="content" class="image-bg4">
            <div class="container">
                <div class="row">
                    <!-- Begin:Content-FlightSearchTabs-Booking -->
                    <div id="main" class="col-sm-8 col-md-9">
                        <sdr-shared-flightsearch-tabs modulo="rebooking"></sdr-shared-flightsearch-tabs>
                    </div>
                    <!-- Begin:Content-FlightSearchTabs-Booking -->


                    <!-- Begin:Content-SideBar-Direct -->
                    <div class="sidebar col-sm-4 col-md-3">
                        <sdr-promobox-direkt></sdr-promobox-direkt>
                    </div>
                    <!-- End:Content-SideBar-Direct -->
                </div>
            </div>
        </section>
        <!-- End:PageContent:Main -->


        <!-- Begin:Content:RebookingBookingnoOverview -->
        <sdr-rebooking-bookingnooverview modulo="rebooking"></sdr-rebooking-bookingnooverview>
        <!-- End:Content:RebookingBookingnoOverview -->
    </div>
</template>

<script>
    import FlightSearchTabs from '../shared/flightsearch/FlightSearchTabs.vue'; // Entire Tabs Construct (shared)
    import RebookingBookingnoOverview from './pagecontent/BookingnoOverview.vue';
    import PromoBoxDirect from '../shared/sidebar/Banner1.vue';


    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-shared-flightsearch-tabs': FlightSearchTabs,
            'sdr-rebooking-bookingnooverview': RebookingBookingnoOverview,
            'sdr-promobox-direkt': PromoBoxDirect,

        }, // eo components{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>

</style>
